const CustomHr = () => {
    return (
        <div className="w-full h-[2px] bg-neutral-300 mb-8"></div>
    )
}

export default CustomHr;